const orcamentoDash = {
  id: "orcamento",
  titulo: "Orçamento",
  pathModulo: "/orcamento-dash",
  icone: "Wallet",
  // Mesma lista de `todasRolesPermitidas` calculada em routes.js para a rota
  // /orcamento-dash (rolesAtuais + variantes "COORDENADOR_*") — copiada aqui
  // porque essa lista é montada dinamicamente dentro do componente de rotas.
  allowedRoles: [
    "admin",
    "RH",
    "TI",
    "ADMFIN",
    "NEGOCIOS",
    "EXECUTIVA",
    "VIAGENS",
    "FACILITIES",
    "COMERCIAL",
    "QUALIDADE",
    "JURIDICO",
    "OPERACAO",
    "MARKETING",
    "GESTOR_ESTRATEGICO",
    "PESSOA&CULTURA",
    "VIAGEMCOMERCIAL",
    "VIAGEMFACILITIES",
    "COORDENADOR_admin",
    "COORDENADOR_RH",
    "COORDENADOR_TI",
    "COORDENADOR_ADMFIN",
    "COORDENADOR_NEGOCIOS",
    "COORDENADOR_EXECUTIVA",
    "COORDENADOR_VIAGENS",
    "COORDENADOR_FACILITIES",
    "COORDENADOR_COMERCIAL",
    "COORDENADOR_QUALIDADE",
    "COORDENADOR_JURIDICO",
    "COORDENADOR_OPERACAO",
    "COORDENADOR_MARKETING",
    "COORDENADOR_GESTOR_ESTRATEGICO",
    "COORDENADOR_PESSOA&CULTURA",
    "COORDENADOR_VIAGEMCOMERCIAL",
    "COORDENADOR_VIAGEMFACILITIES",
  ],
  descricao:
    "Painel de acompanhamento orçamentário: compara o valor Orçado com o Realizado (lançamentos financeiros somados à mão de obra/folha) por departamento, grupo e mês, com indicador de eficiência de execução e detalhamento até o nível de conta e lançamento individual. O acesso é por departamento — cada role vê apenas os dados da sua própria diretoria/área, exceto perfis com visão ampla (admin) ou multi-departamental (Gestor Estratégico).",
  passoAPasso: [
    {
      titulo: "Confira qual recorte de dados você enxerga",
      texto:
        "O que aparece no painel depende da sua role: cada perfil de departamento (RH, TI, Comercial, Marketing, Jurídico etc.) vê apenas os lançamentos e o orçamento do seu próprio departamento. Um \"COORDENADOR_*\" vê o mesmo departamento da sua área, mas sem os grupos de Salários e Encargos / Benefícios. Apenas admin tem visão irrestrita de todos os departamentos.",
    },
    {
      titulo: "Use os filtros",
      texto:
        "Categorias, Grupos, Departamento e Mês, no topo da tela. Grupo e Categoria são hierárquicos (escolher um Grupo restringe as Categorias disponíveis) e o filtro de Mês aceita tanto um mês específico quanto um trimestre inteiro (1º ao 4º Trimestre).",
    },
    {
      titulo: "Acompanhe os KPIs no topo",
      texto:
        "Orçamento (total orçado no recorte filtrado), Realizado (total já lançado) e Delta Realizado (o quanto ainda resta do orçamento, orçado menos o valor absoluto do realizado).",
    },
    {
      titulo: "Leia os gráficos",
      texto:
        "\"Orçamento · Realizado · Aprovado — por Departamento\" compara os departamentos lado a lado; \"Gastos por Grupo\" mostra Realizado × Orçado por categoria superior; \"Evolução Orçado vs Realizado\" traça a linha mensal (orçado tracejado, realizado sólido) com o desvio percentual no tooltip; e o gauge \"Eficiência Orçamentária\" resume o % de execução (Realizado / Orçado) do recorte atual.",
    },
    {
      titulo: "Detalhe uma linha da tabela",
      texto:
        "Na tabela final, clique no ícone \"≡\" da coluna Orçamento para ver o detalhamento por Grupo → Conta do valor orçado; no ícone da coluna Realizado para ver os lançamentos individuais (cliente/fornecedor, valor, data, observação); e no ícone da coluna Comparativo para abrir o comparativo Orçado vs Realizado por grupo, com o % de execução de cada um.",
    },
  ],
  dicas: [
    "A folha de pagamento (mão de obra) do mês corrente entra no Realizado como projeção até o fechamento contábil — o próprio detalhamento por departamento avisa isso.",
    "Use a coluna \"% Exec.\" da tabela para achar rapidamente departamentos que já ultrapassaram o orçado: verde é execução baixa, laranja/amarelo é atenção, vermelho (≥100%) é orçamento estourado.",
    "Combine o filtro de Mês com um Trimestre (Q1 a Q4) para consolidar a visão sem precisar somar meses manualmente.",
    "O botão de tema (sol/lua) no cabeçalho alterna entre claro e escuro — a preferência não é salva entre sessões.",
  ],
  faq: [
    {
      pergunta: "Por que eu só vejo os dados do meu departamento?",
      resposta:
        "O acesso ao módulo de Orçamento é por role: cada perfil de área (RH, TI, Comercial, Marketing, Jurídico, Facilities, Viagens etc.) enxerga somente o departamento correspondente à sua função. Apenas admin tem visão total, e Gestor Estratégico vê três diretorias específicas (Jurídica, Processos e Qualidade, Executiva).",
    },
    {
      pergunta: "O que é o \"Delta Realizado\" mostrado nos KPIs?",
      resposta:
        "É o saldo restante do orçamento no recorte filtrado: o valor Orçado menos o valor absoluto do Realizado. Um delta negativo indica que o gasto já superou o que foi orçado.",
    },
    {
      pergunta: "Por que os valores de mão de obra aparecem junto com os lançamentos?",
      resposta:
        "O realizado de mão de obra (folha) é normalizado e mesclado automaticamente aos lançamentos financeiros para compor o total Realizado de cada departamento e grupo — por isso ele aparece nos gráficos, na tabela e no detalhamento por departamento.",
    },
    {
      pergunta: "Por que as opções de Categoria mudam quando eu troco o Grupo?",
      resposta:
        "Os filtros são hierárquicos por design (Grupo → Categoria → Departamento) para evitar combinações inválidas — trocar o Grupo recalcula quais categorias realmente existem dentro dele.",
    },
  ],
};

export default orcamentoDash;
